import React, { Fragment, memo, useMemo, useState } from "react";
import { Col, Row, InputGroup } from 'react-bootstrap';
import Input from "../../elements/CustomInput";
import InputFile from "../../elements/CustomFileInput";
import CustomCurrencyInput from "../../elements/CustomCurrencyInput";
import NumaricInput from "../../elements/NumaricInput";
import Select from "../../elements/CustomSelect";
import Checkbox from "../../elements/CustomCheckBox";
import {
	CARPET_ID_DB,
  SHEET_VINYL_ID_DB,
  VINYL_PLANK_ID_DB,
  WALLBASE_ID_DB,
  INSTALLATION_ACCESSORIES_ID_DB,
  TRANSITION_ID_DB,
  CABINET_BOX_ID_DB,
  COUNTER_TOP_ID_DB,
  CABINET_DOOR_ID_DB,
  CABINET_SUBSTRATE_ID_DB,
  THERMOFOIL_ID_DB,
  FIXTURES_ID_DB
	} from "../../../_utils/constants/ProductCatalog";
import { ic_mode_edit } from 'react-icons-kit/md';
import {ic_close} from 'react-icons-kit/md/ic_close'
import { Button } from "react-bootstrap";
import Icon from "react-icons-kit";
import { Form } from 'react-bootstrap';

const FormElements = ({
  productStructure,
  units,
  storeList,
  state,
  handleChange,
  handleFileChange,
  vendorList,
  handleChangeCurrency,
  numberValidation,
  numberValidationCons,
  coverageNum,
  ids,
  piecesNumberValidation,
  productSubStructure,
  handleChangeColor,
  handleDeleteFile
}) => {
  const filterInput = useMemo(() => {
    if (state.ProductTypeId) {
      let projectType = productStructure.find(f => f.value === parseInt(state.ProductTypeId));
      if (projectType.value === CARPET_ID_DB) {
        return 1;
      } else if (projectType.value === SHEET_VINYL_ID_DB) {
        return 2;
      } else if (projectType.value === VINYL_PLANK_ID_DB) {
        return 3;
      } else if (projectType.value === INSTALLATION_ACCESSORIES_ID_DB) {
        return 4;
      } else if (projectType.value === WALLBASE_ID_DB) {
        return 5;
      } else if (projectType.value === TRANSITION_ID_DB) {
        return 6;
      } else if (projectType.value === CABINET_BOX_ID_DB) {
        return 7;
      } else if (projectType.value === COUNTER_TOP_ID_DB) {
        return 8;
      } else if (projectType.value === CABINET_DOOR_ID_DB) {
        return 9;
      } else if (projectType.value === CABINET_SUBSTRATE_ID_DB) {
        return 10;
      } else if (projectType.value === THERMOFOIL_ID_DB) {
        return 11;
      } else if (projectType.value === FIXTURES_ID_DB) {
        return 12;
      }
       else {
        return 1
      }
    }

  }, [state.ProductTypeId])

  const handleValue = (value) => {
    if (value) {
      return value
    }
  }
  const [coverageUnitArr, setCoverageUnitArr] = useState([]);
  const [faceFrameTypes, setFaceFrameTypes] = useState([]);
  const [doorSubstrates, setDoorSubstrates] = useState([]);
  const [counterTopTypes, setCounterTopTypes] = useState([]);
  const [thermofoilTypes, setThermofoilTypes] = useState([]);
  const [isEditFile, setIsEditFile] = useState(false);
  const [filteredStoreList, setFilteredStoreList] = useState([]);

  useMemo(() => {
    if (state.ProductTypeId && productStructure) {
      const projectType = productStructure.find(f => f.value === parseInt(state.ProductTypeId));
      if (projectType?.isCountertopCabinet) {
        setFilteredStoreList(storeList.filter(s => s.storeTypeId === 2));
      } else {
        setFilteredStoreList(storeList.filter(s => s.storeTypeId === 1));
      }
    } else {
      setFilteredStoreList(storeList.filter(s => s.storeTypeId === 1));
    }
  }, [state.ProductTypeId, productStructure, storeList]);
  useMemo(() => {
    setFaceFrameTypes([
      {
        "value": 2,
        "label": "Framed",
      },
      {
        "value": 3,
        "label": "Frameless",
      }
    ])
    setThermofoilTypes([
      {
        "value": 2,
        "label": "Preglued",
      },
      {
        "value": 3,
        "label": "Not Glued",
      }
    ])
    setDoorSubstrates([
      {
        "value": 1,
        "label": "Single Sided",
      },
      {
        "value": 2,
        "label": "Double Sided",
      }
    ])
    setCounterTopTypes([
      {
        "value": 2,
        "label": "Kitchen",
      },
      {
        "value": 3,
        "label": "Vanity",
      },
      {
        "value": 4,
        "label": "Double Roll",
      },
      {
        "value": 5,
        "label": "Single Roll",
      }
    ])
    setCoverageUnitArr([
      {
        "value": 21,
        "label": "SY",
      },
      {
        "value": 24,
        "label": "SF",
      },
      {
        "value": 25,
        "label": "EA",
      },
      {
        "value": 26,
        "label": "LF",
      },
      {
        "value": 30,
        "label": "Roll",
      }
    ])
  }, [])
  const handleEditFile = (e, value, isDelete) => {
    setIsEditFile(!isEditFile)
    handleDeleteFile(isDelete)
  }
  return (
    <Fragment>
      <Row className="justify-content-center">
        <Col md={4} className="mb-3">
          <Select label={`Product Structure`} result={productStructure} ids="ProductTypeId" value={state.ProductTypeId} handleChange={handleChange} validate={true} />
        </Col>
        {filterInput === 4 || filterInput === 5 || filterInput === 6 || filterInput === 12 ? 
          <Col md={4} className="mb-3">
            <Select label={`Product Sub Structure`} result={productSubStructure} ids="subProductTypeId" value={state.subProductTypeId} handleChange={handleChange} validate={true} />
          </Col> : null
        }
      </Row>
      <Row className={` ${state.ProductTypeId ? null : 'd-none'}`}>
      { filterInput === 4 || filterInput === 5 || filterInput === 6 ? (
        <Row className="justify-content-center">
          <Col md={4} className="mb-3 ms-3">
            <Checkbox label={`Common Add Ons`} ids="isAddOn" value={state.isAddOn} handleChange={handleChange} validate={false} />
          </Col>
        </Row>) : null
      }
        <Col lg={4} md={6}>
          <Select label={`Store Name`} ids={`StoreId`} result={filteredStoreList} handleChange={handleChange} value={state.StoreId} validate={true} />
        </Col>
        <Col lg={4} md={6} className="mb-3">
          {!ids
            ? (<Row className="justify-content-center align-items-center">
                <Col sm={12} >
                  <InputFile label={`Photo`} ids={`Files`} title={state.Files ? state.Files.name: state.PhotoPath} value={state.Files} validate={false} handleFileChange={handleFileChange} />
                </Col>
                {/*<Col sm={2}>
                  <Button variant="flat" className="px-1 py-0" onClick={(e) => handleEditFile(e, state)}>
                  </Button>
                </Col>*/}
              </Row>)
            :  <div>
              {isEditFile ? (
                <Row className="justify-content-center align-items-center">
                  <Col sm={10}>
                    <InputFile label={`Photo`} ids={`Files`} title={state.Files ? state.Files.name: state.PhotoPath} value={state.Files} validate={false} handleFileChange={handleFileChange} />
                  </Col>
                  <Col sm={2} className="px-0">
                    <Button variant="flat" className="p-0" onClick={(e) => handleEditFile(e, state, true)}>
                      <Icon size={18} icon={ic_close} />
                    </Button>
                  </Col>
                </Row>
                ) : (
                <Row className="justify-content-center align-items-end">
                  <Col sm={10}>
                    <Input label={`Photo`} value={state.PhotoPath} validate={false} disabled={true} />
                  </Col>
                  <Col sm={2}>
                    <Button variant="flat" className="px-1" onClick={(e) => handleEditFile(e, state, false)}>
                      <Icon size={18} icon={ic_mode_edit} />
                    </Button>
                  </Col>
                </Row>
              )}
            </div>
          }
        </Col>
        {/* <Col lg={4} md={6} className="mb-3">
          <Select label={`Vendor`} result={vendorList} ids="VendorId" handleChange={handleChange} value={state.VendorId} validate={false} />
        </Col> */}
        <Col lg={3} md={6} className="mb-3">
          <Input label={`Private Name`} ids={`PrivateName`} handleChange={handleChange} value={state.PrivateName} validate={false} />
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <Input label={`Manufacturer`} ids={`Manufacturer`} handleChange={handleChange} value={state.Manufacturer} validate={true} />
        </Col>
         {(filterInput === 7 || filterInput === 8 || filterInput === 9 || filterInput === 10 || filterInput === 11 || filterInput === 12) ? (<Col lg={3} md={6} className="mb-3">
          <Input label={`Product Name`} ids={`ProductName`} handleChange={handleChange} value={state.ProductName} validate={true} />
        </Col>) : null}
        <Col lg={3} md={6} className="mb-3">
          <Input label={`Style`} ids={`Style`} handleChange={handleChange} value={state.Style} validate={true} />
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <Input label={`Color`} ids={`Color`} handleChange={handleChange} value={state.Color} validate={true} />
        </Col>
        {filterInput === 10 ? (
          <Col lg={3} md={6} className="mb-3">
            <Select label={`Single or Double Sided`} ids={`SingleOrDoubleSided`} result={doorSubstrates} handleChange={handleChange} value={state.SingleOrDoubleSided} validate={false} />
          </Col>       
        ) : null}
        {filterInput === 11 ? (
          <Col lg={3} md={6} className="mb-3">
            <Select label={`Pre Glued`} ids={`PreGlued`} result={thermofoilTypes} handleChange={handleChange} value={state.PreGlued} validate={false} />
          </Col>       
        ) : null}
        {filterInput === 7 ? (
          <Fragment>
            <Col lg={3} md={6} className="mb-3">
              <Select label={`Face Frame Type`} ids={`FaceFrameType`} result={faceFrameTypes} handleChange={handleChange} value={state.FaceFrameType} validate={true} />
            </Col>       
            <Col lg={3} md={6} className="mb-3">
              <NumaricInput label={`Height(in)`} ids={`Height`} handleChange={handleChange} value={state.Height} validate={true} />
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <NumaricInput label={`Width(in)`} ids={`Width`} handleChange={handleChange} value={state.Width} validate={true} />
            </Col>
          </Fragment>
        ) : null}
        {filterInput === 8 ? (
          <Fragment>
            <Col lg={3} md={6} className="mb-3">
              <Select label={`Countertop Type`} ids={`CountertopType`} result={counterTopTypes} handleChange={handleChange} value={state.CountertopType} validate={true} />
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Input label={`Edge Profile`} ids={`EdgeProfile`} handleChange={handleChange} value={state.EdgeProfile} validate={true} />
            </Col>
          </Fragment>
        ) : null}
        {filterInput === 5 || filterInput === 6 ?
          <Col lg={3} md={6} className="mb-3">
            <Form.Label>Color Picker</Form.Label>
            <InputGroup>
              <Form.Control type="text" className="w-50" name={`customColorCode`} id={`customColorCode`} onChange={e=>handleChangeColor(e)} value={state.customColor} />
              <Form.Control type="color" name={`customColor`} id={`customColor`} onChange={e=>handleChangeColor(e)} value={state.customColor} />
            </InputGroup>
          </Col> : null
        }
        <Col lg={3} md={6} className="mb-3">
          <Select label={`Unit`} ids={`UnitId`} result={units} handleChange={handleChange} value={state.UnitId} validate={true} />
        </Col>
        {filterInput === 1 || filterInput === 2 || filterInput === 3 || filterInput === 10 || filterInput === 11 || filterInput === 12 ? (
          <Fragment>
            <Col lg={3} md={6} className="mb-3">
              <NumaricInput label={`Length${filterInput === 3 ? " (in)" : " (ft)"}`} ids={`Length`} handleChange={handleChange} value={state.Length} validate={(filterInput === 3 || filterInput === 10 || filterInput === 11 || filterInput === 12) ? true : false} />
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Input label={`Width${filterInput === 3 ? " (in)" : " (ft)"}`} ids={`Width`} handleChange={handleChange} value={handleValue(state.Width)} validate={true} />
              {numberValidation ? (
                <span className="text-danger" fontSize={`12`}>{numberValidation}</span>
              ) : null}
            </Col>
          </Fragment>
        ) : null}

        {filterInput === 10 ? (<Col lg={3} md={6} className="mb-3">
          <NumaricInput label={`Thickness`} ids={`Thickness`} handleChange={handleChange} value={state.Thickness} validate={true} />
        </Col>) : null}

        {filterInput === 4 || filterInput === 5 || filterInput === 6 || filterInput === 8 || filterInput === 10 || filterInput === 11 || filterInput === 12 ? (
          <Fragment>
            <Col lg={3} md={6} className="mb-3">
              <Input label={`Coverage`} ids={`coverage`} handleChange={handleChange} value={state.coverage} validate={(filterInput === 5 || filterInput === 8 || filterInput === 10 || filterInput === 11 || filterInput === 12) ? true : false} />

              {coverageNum ? (
                <span className="text-danger" fontSize={`12`}>{coverageNum}</span>
              ) : null}
            </Col>
            {filterInput !== 6 ? (
              <Col lg={3} md={6} className="mb-3">
                <Select label={`Coverage Unit`} ids={`coverageUnit`} result={coverageUnitArr} handleChange={handleChange} value={state.coverageUnit} validate={(filterInput === 8 || filterInput === 10 || filterInput === 11 || filterInput === 12) ? true : false} />
              </Col>
            ) : null}

            <Col lg={3} md={6} className="mb-3">
              <Select label={`Coverage Per Unit`} ids={`coveragePerUnit`} result={coverageUnitArr} handleChange={handleChange} value={state.coveragePerUnit} validate={(filterInput === 8 || filterInput === 10 || filterInput === 11 || filterInput === 12) ? true : false} />
            </Col>
          </Fragment>
        ) : null}
        {filterInput === 1 ? (
          <Fragment>
            <Col lg={3} md={6} className="mb-3">
              <NumaricInput label={`Face Weight`} ids={`FaceWidth`} handleChange={handleChange} value={state.FaceWidth} validate={true} />
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Select label={`Fiber Content`} result={[{ label: "PET", value: "PET" }, { label: "Nylon", value: "Nylon" }]} ids="Fiber" value={state.Fiber} handleChange={handleChange} validate={true} />
            </Col>
          </Fragment>
        ) : filterInput === 2 ? (
          <Col lg={3} md={6} className="mb-3">
            <NumaricInput label={`Guage`} ids={`Guage`} handleChange={handleChange} value={state.Guage} validate={true} />
          </Col>
        ) : filterInput === 3 ? (
          <Fragment>
            <Col lg={3} md={6} className="mb-3">
              <NumaricInput label={`Thickness`} ids={`Thickness`} handleChange={handleChange} value={state.Thickness} validate={true} />
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <NumaricInput label={`Wear Layer`} ids={`wearLayer`} handleChange={handleChange} value={state.wearLayer} validate={true} />
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <NumaricInput label={`Box QTY`} ids={`BoxQTY`} handleChange={handleChange} value={state.BoxQTY} validate={true} />
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Input label={`Pieces Per box`} ids={`piecesPerBox`} handleChange={handleChange} value={state.piecesPerBox} validate={true} />
              {piecesNumberValidation ? (
                <span className="text-danger">{piecesNumberValidation}</span>
              ) : null}
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Input label={`SF Per Piece`} ids={`sfPerPiece`} value={state.sfPerPiece} disabled={true} validate={false} />
            </Col>
          </Fragment>
        ) : null}
        {filterInput === 2 ? (
          <Col lg={3} md={6} className="mb-3">
            <Select label={`Backing Type`} ids={`backingType`} result={[{ label: "Fiberglass", value: "Fiberglass" }, { label: "Felt", value: "Felt" }]} handleChange={handleChange} value={state.backingType} validate={false} />
          </Col>
        ) : null}
        {filterInput !== 9 ? (<Col lg={3} md={6} className="mb-3">
          <Input label={`Manufacturer SKU`} ids={`ManufacturerSKU`} handleChange={handleChange} value={state.ManufacturerSKU} validate={true} />
        </Col>) : null}
        {filterInput === 8 ? (<><Col lg={3} md={6} className="mb-3">
          <NumaricInput label={`Length (ft)`} ids={`Length`} handleChange={handleChange} value={state.Length} validate={true} />
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <NumaricInput label={`Depth (in)`} ids={`Depth`} handleChange={handleChange} value={state.Depth} validate={true} />
        </Col>
        </>) : null}

        <Col lg={3} md={6} className="mb-3">
          <CustomCurrencyInput label={`Current Cost`} ids={`CurrentCost`} handleChange={handleChangeCurrency} value={handleValue(state.CurrentCost)} validate={true} />
        </Col>
        {filterInput === 7 ? (<Col lg={3} md={6} className="mb-3">
          <NumaricInput label={`Cost Multiplier`} ids={`CostMultiplier`} handleChange={handleChange} value={state.CostMultiplier} validate={true} />
        </Col> ) : null}
        {filterInput !== 9 && filterInput !== 10 ? (<Col lg={3} md={6} className="mb-3">
          <CustomCurrencyInput label={`Current Freight`} ids={`CurrentFreight`} handleChange={handleChangeCurrency} value={handleValue(state.CurrentFreight)} validate={true} />
          {numberValidationCons ? (
            <span className="text-danger" >{numberValidationCons}</span>
          ) : null}
        </Col> ) : null}
        { ids &&
          <Col lg={3} md={6} className="mb-3">
            <Input label={`Product ID`} value={ids} disabled={true} validate={false} />
          </Col>
        }
        <Col lg={3} md={6} className="mb-3">
          <label className="form-label" >Stock</label>
          <Checkbox label={``} ids="IsStock" value={(state.IsStock  || state.IsStock === 'on') ? true: false} handleChange={handleChange} validate={false} />
        </Col>
      </Row>
    </Fragment>

  )
}


export default memo(FormElements);